import { HStack, VStack, Typography, Show } from 'shared';
import Box from 'shared_DEPRECATED/components/Box';

import { SessionsFormCoachingToolsCompletionIndicator } from 'features/sessions/components/Form/CoachingTools/CompletionIndicator';
import { TABLE_CELL_DEFAULT_VALUE } from 'features/sessions/config';
import { Tool } from 'features/sessions/config/types';
import { isHosCoachingTool } from 'features/sessions/utils';

type SessionsTableCoachingToolsCellProps = {
  value: Tool[];
};

export const SessionsTableCoachingToolsCell = ({
  value: coachingTools,
}: SessionsTableCoachingToolsCellProps) => (
  <Box style={{ maxWidth: '12rem' }}>
    {coachingTools?.length > 0 ? (
      <VStack gap={1} alignItems="flex-start">
        {coachingTools.map((tool, index) => (
          <HStack key={index} gap={1}>
            <Typography
              type="small"
              color="gray"
              fontWeight="regular"
              dataTestid="session-coaching-tool-cell"
            >
              {tool.label}
            </Typography>
            <Show when={isHosCoachingTool(tool)}>
              <SessionsFormCoachingToolsCompletionIndicator
                isCompleted={tool.isCompleted}
                showLabel={false}
              />
            </Show>
          </HStack>
        ))}
      </VStack>
    ) : (
      <Typography
        type="small"
        color="gray"
        fontWeight="regular"
        dataTestid="session-coaching-tool-cell"
      >
        {TABLE_CELL_DEFAULT_VALUE}
      </Typography>
    )}
  </Box>
);
